import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyAssistants = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m14.801 15.759-.292-.732a2.678 2.678 0 0 0-.67-.977l-.053-.05a2.497 2.497 0 0 0-1.698-.666H7.909c-.63 0-1.236.238-1.699.666l-.053.05a2.688 2.688 0 0 0-.67.976l-.292.733M12.065 6.206A2.917 2.917 0 1 1 7.94 10.33a2.917 2.917 0 0 1 4.125-4.125",
		stroke: "#748094",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697",
		stroke: "#748094",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMyAssistants;
